// pages/auth/Login.jsx - Versión actualizada
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import SEO from '../../components/common/SEO';
import styles from './Login.module.css';

const Login = () => {
  const [formData, setFormData] = useState({ email: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { fetchCartItems } = useCart();

  const handleInputChange = (e) => {
    setFormData({ email: e.target.value });
    setError('');
  };

  const handleCustomerAccess = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      if (!formData.email) {
        setError('Por favor ingresa tu email para continuar');
        setLoading(false);
        return;
      }
      localStorage.setItem('guest_email', formData.email);
      localStorage.setItem('user_type', 'guest');
      await fetchCartItems();
      navigate('/');
    } catch (err) {
      setError('Error al procesar el acceso');
      console.error('Guest access error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <SEO 
        title="Iniciar Sesión - Nexa Global"
        description="Ingresa a tu cuenta"
        noindex={true}
      />
      <div className={styles.loginCard}>
        <div className={styles.loginHeader}>
          <h1>MiTienda</h1>
          <h2>Continuar como Invitado</h2>
          {error && <div className={styles.errorMessage}>{error}</div>}
        </div>
        <form className={styles.loginForm} onSubmit={handleCustomerAccess}>
          <div className={styles.formGroup}>
            <label htmlFor="email">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleInputChange}
              required
              placeholder="tu.email@ejemplo.com"
              className={error ? styles.inputError : ''}
              disabled={loading}
            />
          </div>
          <button type="submit" className={styles.loginButton} disabled={loading}>
            {loading ? (
              <div className={styles.loading}>
                <div className={styles.spinner}></div>
                Accediendo...
              </div>
            ) : (
              'Continuar como Invitado'
            )}
          </button>
        </form>
        <div className={styles.loginFooter}>
          <div className={styles.guestInfo}>
            <h3>¿Por qué necesitamos tu email?</h3>
            <ul>
              <li>• Para procesar tu pedido</li>
              <li>• Enviarte confirmación de compra</li>
              <li>• Notificarte sobre el estado de tu envío</li>
            </ul>
            <p className={styles.privacy}>
              Tu privacidad es importante para nosotros. 
              <Link to="/privacy"> Ver política de privacidad</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Login;